import { render, staticRenderFns } from "./PlanAction.vue?vue&type=template&id=fc4a6fa8"
import script from "./PlanAction.vue?vue&type=script&lang=js"
export * from "./PlanAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports